import { Button, Flex, Grid, Modal, Typography } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

type OpenedPropsType = {
  title: string;
  text?: string;
  number: string;
  price?: string;
  action: () => void;
};
export type TaskActionType = {
  open: (actNumber: OpenedPropsType) => void;
  close: () => void;
};

export const TaskActionModal = forwardRef<TaskActionType>((_, ref) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const [openedProps, setOpenedProps] = useState<OpenedPropsType | null>(null);

  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs === true;

  const open = (openedProps: OpenedPropsType) => {
    setOpenedProps(openedProps);
    setOpened(true);
  };

  const close = () => {
    setOpened(false);
  };

  useImperativeHandle(ref, () => ({
    open: (openedProps: OpenedPropsType) => open(openedProps),
    close: () => close(),
  }));

  return (
    <Modal
      title={
        <Typography.Title level={3}>{openedProps?.title}</Typography.Title>
      }
      open={opened}
      onCancel={close}
      footer={
        <Flex gap="small" justify="end">
          <Button onClick={() => close()}>{t("common.cancel")}</Button>
          <Button type="primary" onClick={() => openedProps?.action()}>
            {t("common.confirm")}
          </Button>
        </Flex>
      }
      style={isMobile ? { top: "25%" } : {}}
      className={styles.TaskActionModal}
    >
      {openedProps?.text && (
        <>
          <Typography.Text>{openedProps?.text}</Typography.Text>
          <br />
        </>
      )}
      <Typography.Text>{openedProps?.number}</Typography.Text>
      <br />
      <Typography.Text>{openedProps?.price}</Typography.Text>
    </Modal>
  );
});
